// A confirmation in AlphaLab's style, instead of window.confirm (design-revamp.md section 4).
import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "./ui/button.js";

export interface ConfirmRequest {
  title: string;
  body: string;
  confirm: string;
  onConfirm(): void;
}

export function Confirm({ request, onClose }: { request: ConfirmRequest | undefined; onClose(): void }) {
  return (
    <Dialog.Root open={request !== undefined} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed top-1/2 left-1/2 z-50 w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 rounded-xl border border-border bg-card p-5 text-card-foreground shadow-lg">
          <Dialog.Title className="text-base font-semibold">{request?.title}</Dialog.Title>
          <Dialog.Description className="mt-2 whitespace-pre-wrap text-sm text-muted-foreground">{request?.body}</Dialog.Description>
          <div className="mt-5 flex justify-end gap-2">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                request?.onConfirm();
                onClose();
              }}
            >
              {request?.confirm}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
